module.exports = __webpack_public_path__ + "static/media/qsbg.37c040d8.png";